import { useSearchParams, Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "../components/ui/button";
import { CheckCircle, ArrowRight, AlertTriangle } from "lucide-react";

export default function OrderConfirmationPage() {
    const [params] = useSearchParams();
    const method = params.get("method") || "wire";
    const orderNumber = params.get("order") || "";

    useEffect(() => {
        if (window.gtag) {
            window.gtag('event', 'conversion', { 'send_to': 'AW-17745314707/myjOCKKlx9obEJOH0I1C' });
        }
    }, []);

    return (
        <div className="min-h-[70vh]" data-testid="order-confirmation-page">
            <div className="container mx-auto px-6 lg:px-12 py-16 lg:py-24 max-w-3xl">
                <div className="text-center mb-10">
                    <div className="w-20 h-20 bg-primary/10 border border-primary/20 flex items-center justify-center mx-auto mb-6">
                        <CheckCircle className="h-10 w-10 text-primary" />
                    </div>
                    <h1 className="font-heading text-4xl sm:text-5xl font-black text-foreground tracking-tight mb-3">
                        Order Confirmed!
                    </h1>
                    <p className="text-muted-foreground text-base">
                        Thank you for choosing Dry Ice Bulls as your premier dry ice cleaning partner.
                    </p>
                    {orderNumber && (
                        <p className="text-foreground font-mono text-sm mt-2">Order Number: <span className="text-primary font-bold">{orderNumber}</span></p>
                    )}
                </div>

                <div className="bg-card border border-border p-6 mb-6">
                    <h2 className="font-heading font-bold text-lg text-foreground mb-4">What Happens Next</h2>
                    <div className="space-y-4 text-sm text-muted-foreground">
                        <div className="flex gap-3">
                            <span className="w-6 h-6 bg-primary text-primary-foreground flex items-center justify-center text-xs font-bold shrink-0">1</span>
                            <p><strong className="text-foreground">Automated Invoice:</strong> A formal commercial invoice has been emailed to your address on file.</p>
                        </div>

                        {method === "wire" && (
                            <div className="flex gap-3">
                                <span className="w-6 h-6 bg-primary text-primary-foreground flex items-center justify-center text-xs font-bold shrink-0">2</span>
                                <div>
                                    <p><strong className="text-foreground">Wire Transfer:</strong> Please execute the transfer using the routing information found in your invoice email.</p>
                                    <div className="bg-muted/30 border border-border p-4 mt-3 space-y-1">
                                        <p><strong>Bank:</strong> JPMorgan Chase Bank, N.A.</p>
                                        <p><strong>Account Name:</strong> Dry Ice Bulls LLC</p>
                                        <p><strong>Account Number:</strong> 2905813775</p>
                                        <p><strong>Routing Number:</strong> 072000326</p>
                                    </div>
                                    <p className="mt-2 text-xs">Equipment is securely reserved for 72 business hours pending wire receipt.</p>
                                </div>
                            </div>
                        )}

                        {method === "financing" && (
                            <div className="flex gap-3">
                                <span className="w-6 h-6 bg-primary text-primary-foreground flex items-center justify-center text-xs font-bold shrink-0">2</span>
                                <p><strong className="text-foreground">Financing:</strong> Please complete the automated TimePayment application. Our team will follow up within 24 hours to confirm your financing approval.</p>
                            </div>
                        )}

                        {method === "credit_card" && (
                            <>
                                <div className="flex gap-3">
                                    <span className="w-6 h-6 bg-primary text-primary-foreground flex items-center justify-center text-xs font-bold shrink-0">2</span>
                                    <p><strong className="text-foreground">Credit Card:</strong> Your split-card authorization receipts are processing.</p>
                                </div>
                                <div className="bg-yellow-500/10 border border-yellow-500/30 p-4 flex gap-3">
                                    <AlertTriangle className="h-5 w-5 text-yellow-500 shrink-0 mt-0.5" />
                                    <div>
                                        <p className="font-bold text-foreground text-sm">CRITICAL: Credit Card Authorization Required</p>
                                        <p className="text-xs mt-1">A "Credit Card Authorization & Right-to-Dispute Waiver Form" has been sent to your email. This form must be completed, physically signed by the cardholder, and emailed back to <a href="mailto:info@dryicebulls.com" className="text-primary">info@dryicebulls.com</a> before your freight carrier tracking number can be issued.</p>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>

                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <Link to="/products">
                        <Button className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-none uppercase font-bold tracking-wider px-8">
                            Continue Shopping <ArrowRight className="ml-2 h-4 w-4" />
                        </Button>
                    </Link>
                    <Link to="/">
                        <Button variant="outline" className="rounded-none uppercase font-bold tracking-wider px-8 border-2">
                            Back to Home
                        </Button>
                    </Link>
                </div>
            </div>
        </div>
    );
}
